import React from 'react';
import { StyleSheet, View, Text } from '../base_components';

import DialogButton from '../buttons/dialog_button';

const styles = StyleSheet.create({
  modalDialog: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.8)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialogWrapper: {
    width: '28em',
    height: '30em',
    backgroundColor: '#003',
    borderWidth: '0.4em',
    borderColor: 'white',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textWrapper: {
    flex: 1,
    alignSelf: 'stretch',
    padding: '1em',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: 'white',
    fontSize: '1.2em',
    lineHeight: '1.7em',
    wordBreak: 'normal',
  },
  buttonWrapper: {
    marginTop: '2em',
    marginBottom: '2em',
    height: '6em',
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
});

let g_globalDialog;

export default class ModalDialog extends React.PureComponent<any, any> {
  state = {
    dialog_type: '',
    title: '',
    text: '',
    positive_button: null,
    negative_button: null,
  } as any;
  componentDidMount() {
    // eslint-disable-next-line consistent-this
    g_globalDialog = this;
  }

  static alert(text: string, button_cb = null) {
    g_globalDialog.setState({ dialog_type: 'alert', text, button_cb });
  }
  static error(text: string, button_cb = null) {
    this.alert(text, button_cb);
  }
  static confirm(opts, button_cb) {
    let text;
    let positive_button = 'OK';
    let negative_button = 'Cancel';
    if (typeof opts === 'string') {
      text = opts;
    } else if (opts) {
      text = opts.text;
      positive_button = opts.positive_button;
      negative_button = opts.negative_button;
    }
    g_globalDialog.setState({
      dialog_type: 'confirm',
      text,
      positive_button,
      negative_button,
      button_cb,
    });
  }

  _clear() {
    this.setState({
      dialog_type: '',
      positive_button: '',
      negative_button: '',
      button_cb: null,
    });
  }

  _onDismiss = (reason: any) => {
    const { button_cb } = this.state;
    this._clear();
    button_cb && button_cb(reason);
  };
  _onPositivePress = () => {
    this._onDismiss(true);
  };
  _onNegativePress = () => {
    this._onDismiss(false);
  };

  render() {
    const { dialog_type, text, positive_button, negative_button } = this.state;

    let content: any = null;
    if (dialog_type === 'alert') {
      content = (
        <View style={styles.modalDialog}>
          <View style={styles.dialogWrapper}>
            <View style={styles.textWrapper}>
              <Text style={styles.text}>{text}</Text>
            </View>
            <View style={styles.buttonWrapper}>
              <DialogButton text='Done' onPress={this._onDismiss} />
            </View>
          </View>
        </View>
      );
    } else if (dialog_type === 'confirm') {
      content = (
        <View style={styles.modalDialog}>
          <View style={styles.dialogWrapper}>
            <View style={styles.textWrapper}>
              <Text style={styles.text}>{text}</Text>
            </View>
            <View style={styles.buttonWrapper}>
              <DialogButton
                text={positive_button || 'OK'}
                onPress={this._onPositivePress}
              />
              <DialogButton
                text={negative_button || 'Cancel'}
                onPress={this._onNegativePress}
              />
            </View>
          </View>
        </View>
      );
    }
    return content;
  }
}
